import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

type ActualsReadOnlyBannerProps = {
  /** True when the coach has Actuals View but not Actuals Log. */
  readOnly: boolean;
};

/**
 * The Bulk Actuals warning banner (SC-4378): with View but not Log the
 * page stays visible but every cell is read-only, so the state change is
 * announced to assistive tech via role="status" rather than hover-only.
 */
export function ActualsReadOnlyBanner({
  readOnly,
}: ActualsReadOnlyBannerProps) {
  const { t } = useTranslation();
  if (!readOnly) return null;
  return (
    <Alert severity="warning" role="status" className="mb-2">
      {t('bulkActualsReadOnly')}
    </Alert>
  );
}
